/**
 * Müzakere hafta kuralları ("YYYY-MM-DD" yerel günler). Mobildeki
 * utils/muzakereWeek.ts ve sunucudaki weekRules.js ile aynı: hafta Pazartesi
 * başlar, üye müzakereyi yalnız müzakerenin günü "Katıldım" işaretler.
 */
import { localDateString, parseLocalDate } from "./dateUtils";

export const todayString = () => localDateString(new Date());

/** Günün bulunduğu haftanın Pazartesi ve Pazar günleri. */
export function weekRange(value) {
  const d = parseLocalDate(value) || new Date();
  const dow = d.getDay(); // 0 = Pazar
  const monday = new Date(d);
  monday.setDate(d.getDate() - (dow === 0 ? 6 : dow - 1));
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  return { start: localDateString(monday), end: localDateString(sunday) };
}

/** Bugüne göre işaretlenebilirlik: "upcoming" | "open" | "expired". */
export function muzakereDayState(date, today = todayString()) {
  if (today < date) return "upcoming";
  return today === date ? "open" : "expired";
}

/**
 * Terakkim'deki müzakere satırının değerlendirme durumu:
 * "plain" (sorusuz), "answer" (cevaplanabilir), "notOpen", "closed", "submitted".
 */
export function memberRowState(assessment) {
  if (!assessment || assessment.state === "none") return "plain";
  if (assessment.submitted) return "submitted";
  if (assessment.state === "open") return "answer";
  if (assessment.state === "ready") return "notOpen";
  return "closed";
}

/**
 * Yuvarlağın durumu: değerlendirmeli müzakerede işaretlenebilirliği günü
 * değil değerlendirme belirler (mobil TerakkimCircles ile aynı).
 */
export function muzakereCircleState(item, today = todayString()) {
  const row = memberRowState(item?.assessment);
  if (row === "plain") return muzakereDayState(item.date, today);
  return row === "answer" ? "open" : "expired";
}

/**
 * Şerit sırası: yapılmamışlar başta, bugüne en yakın olan önce; geçmiş
 * günler bugünü izler, ileri tarihliler en sonda.
 */
export function sortWeekMuzakeres(items, today = todayString()) {
  const t = parseLocalDate(today);
  const near = (date) => {
    const d = parseLocalDate(date);
    if (!d || !t) return 0;
    const diff = Math.round((d - t) / 86400000);
    return diff <= 0 ? -diff : 1000 + diff;
  };
  return [...(items || [])].sort((a, b) =>
    Boolean(a.done) === Boolean(b.done) ? near(a.date) - near(b.date) : a.done ? 1 : -1
  );
}

/** Yönetici üyenin katılımını müzakere gününden sonra kaç gün düzeltebilir. */
export const MANAGER_MARK_DAYS = 7;

/**
 * Yönetici işaretleyebilir ya da değerlendirmeyi başlatabilir mi: müzakere
 * günü ve sonraki 7 gün (mobil canManagerMark, sunucu canManagerMarkOn).
 */
export function canManagerMark(date, today = todayString()) {
  if (!date || today < date) return false;
  const limit = parseLocalDate(date);
  if (!limit) return false;
  limit.setDate(limit.getDate() + MANAGER_MARK_DAYS);
  return today <= localDateString(limit);
}
